"use strict";

exports.__esModule = true;
exports.createCssLayouts = void 0;

var _proLayouts = require("pro-layouts");

var _cssScrollHelper = require("./cssScrollHelper.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// const CDN_URL = 'https://static.wixstatic.com/media/';
var desktopWidths = [480, 768, 1024, 1280, 1440, 1680, 1920, 2560];
var mobileWidths = [320]; //, 375, 414, 480, 600, 768, 900]; (mobile is currently fixed to 320px)

var getImageStyle = function getImageStyle(item, styleParams) {
  return {
    top: item.offset.top,
    left: item.offset.left,
    width: item.width,
    height: item.height + (styleParams.externalInfoHeight || 0)
  };
};

var createItemId = function createItemId(galleryDomId, item) {
  return "#pro-gallery-" + galleryDomId + " #" + _cssScrollHelper.cssScrollHelper.getDomId(item);
};

var createExactCssForItems = function createExactCssForItems(galleryDomId, galleryItems, styleParams) {
  if (galleryDomId === void 0) {
    galleryDomId = '';
  }

  var isRTL = styleParams.isRTL;
  var cssStr = '';
  galleryItems.forEach(function (item, i) {
    var id = createItemId(galleryDomId, item);
    var style = getImageStyle(item, styleParams);
    var T = "top:" + style.top + "px;";
    var L = isRTL ? "right:" + style.left + "px;left:auto;" : "left:" + style.left + "px;";
    var W = "width:" + style.width + "px;";
    var H = "height:" + style.height + "px;";
    cssStr += id + " {" + T + L + W + H + "}"; // cssStr += `${id} .gallery-item-wrapper, ${id} .gallery-item-hover, ${id} .gallery-item {${Wvw}${Hvw}}`;
  });
  return cssStr;
};

var createCssFromLayout = function createCssFromLayout(galleryDomId, layout, styleParams, width) {
  if (galleryDomId === void 0) {
    galleryDomId = '';
  }

  var cssStr = '';
  var layoutWidth = width - styleParams.imageMargin * 2;

  var getRelativeDimension = function getRelativeDimension(val) {
    return Math.round(10000 * (val / layoutWidth)) / 100;
  };

  layout.items.forEach(function (item, i) {
    var id = createItemId(galleryDomId, item);

    if (i < 50) {
      var style = getImageStyle(item, styleParams);
      var Tvw = "top:" + getRelativeDimension(style.top) + "vw;";
      var Wvw = "width:" + getRelativeDimension(style.width) + "vw;";
      var Hvw = "height:" + getRelativeDimension(style.height) + "vw;";
      var Lpc = "left:" + getRelativeDimension(style.left) + "%;";
      var Wpc = "width:" + getRelativeDimension(style.width) + "%;";
      cssStr += id + " {" + Tvw + Lpc + Wpc + Hvw + "}";
      cssStr += id + " .gallery-item-wrapper, " + id + " .gallery-item-hover, " + id + " .gallery-item {" + Wvw + Hvw + "}";
    } else {
      cssStr += id + "{display:none;}";
    }
  });
  return cssStr;
};

var createCssFromLayouts = function createCssFromLayouts(galleryDomId, layouts, styleParams, widths) {
  var cssStrs = [];
  layouts.forEach(function (layout, idx) {
    var cssStr = '';

    if (layout) {
      var width = widths[idx];
      var lastWidth = widths[idx - 1];
      var isFirstMediaQuery = !lastWidth || cssStrs.length === 0;
      cssStr += isFirstMediaQuery ? '' : "@media only screen and (min-width: " + (lastWidth * 2 + width) / 3 + "px) {";
      cssStr += createCssFromLayout(galleryDomId, layout, styleParams, width);
      cssStr += isFirstMediaQuery ? '' : "}";
      cssStrs.push(cssStr);
    }
  });
  return cssStrs;
};

var createCssLayouts = function createCssLayouts(_ref) {
  var isApproximation = _ref.isApproximation,
      galleryItems = _ref.galleryItems,
      layoutParams = _ref.layoutParams,
      isMobile = _ref.isMobile,
      galleryDomId = _ref.galleryDomId;

  if (isApproximation) {
    var widths = isMobile ? mobileWidths : desktopWidths;
    var cssLayouts = widths.map(function (width) {
      var _layoutParams = _objectSpread({}, layoutParams, {}, {
        container: _objectSpread({}, layoutParams.container, {
          galleryWidth: width,
          width: width
        })
      });

      return (0, _proLayouts.createLayout)(_layoutParams);
    });
    return createCssFromLayouts(galleryDomId, cssLayouts, layoutParams.styleParams, widths);
  } else {
    // const chunkSize = 10;
    // const itemsBatchs = [];
    // for (let i = 0; i < galleryItems.length; i += chunkSize) {
    //   itemsBatchs.push(galleryItems.slice(i, i + chunkSize));
    // }
    // return galleryItems.map(items =>
    //   createExactCssForItems(items, layoutParams.styleParams)
    // );
    var exactCss = [];
    exactCss.push(createExactCssForItems(galleryDomId, galleryItems, layoutParams.styleParams));
    return exactCss;
  }
};

exports.createCssLayouts = createCssLayouts;